<template>
  <div v-if="loading" class="dashboard-loading">
    <el-card class="loading-card" shadow="never">
      <el-skeleton animated :rows="6" />
    </el-card>
  </div>

  <EmployeeDashboard
    v-else-if="role === 'Admin' || role === 'Owner'"
    :current-user="currentUser"
  />

  <CustomerDashboard
    v-else
    :current-user="currentUser"
  />
</template>

<script>
import { auth } from '@/firebase'
import CustomerDashboard from '@/components/CustomerDashboard.vue'
import EmployeeDashboard from '@/components/EmployeeDashboard.vue'
import { getUserRole } from '@/services/requests'

export default {
  name: 'DashboardView',
  components: { CustomerDashboard, EmployeeDashboard },
  data() {
    return {
      currentUser: null,
      role: 'User',
      loading: true,
    }
  },
  async mounted() {
    const user = auth.currentUser
    if (!user) {
      this.$router.push({ name: 'Login' })
      return
    }

    this.currentUser = user
    try {
      this.role = await getUserRole(user.uid)
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.dashboard-loading {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top, rgba(11, 108, 255, 0.12), transparent 35%),
    linear-gradient(180deg, #f7fbff 0%, #eef5ff 100%);
}

.loading-card {
  width: min(720px, 100%);
  border-radius: 24px;
  padding: 12px;
}
</style>
